<template>
  <div class="trainer-toggle">
    <div class="trainer-toggle-content">
      <div class="trainer-toggle-text">
        <h3 class="trainer-toggle-title">Персональный тренер</h3>
        <p class="trainer-toggle-description">Показать свободные слоты для занятия с тренером</p>
      </div>
      <button
        class="toggle-switch"
        :class="{ active: modelValue }"
        @click="toggleSwitch"
        role="switch"
        :aria-checked="modelValue"
      >
        <span class="toggle-slider"></span>
      </button>
    </div>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  }
})

const emit = defineEmits(['update:modelValue'])

function toggleSwitch() {
  emit('update:modelValue', !props.modelValue)
}
</script>

<style scoped lang="scss">
@import '@/widgets/booking/assets/scss/variables.scss';

.trainer-toggle {
  padding: 16px;
  background: #F3F5F8;
  border-radius: 12px;
  margin-bottom: $spacing-lg;
}

.trainer-toggle-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.trainer-toggle-text {
  flex: 1;
  min-width: 0;
}

.trainer-toggle-title {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  color: #333333;
  margin: 0 0 4px 0;
}

.trainer-toggle-description {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #757885;
  margin: 0;
}

.toggle-switch {
  position: relative;
  width: 48px;
  height: 28px;
  background: #EEEFF1;
  border-radius: 30px;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: background 0.3s ease;
  flex-shrink: 0;

  &.active {
    background: var(--booking-widget-primary-color, #3C67D6);
  }

  &:hover {
    opacity: 0.9;
  }
}

.toggle-slider {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 24px;
  height: 24px;
  background: #FFFFFF;
  border-radius: 30px;
  transition: transform 0.3s ease;
  display: block;

  .toggle-switch.active & {
    transform: translateX(20px);
  }
}
</style>
